import React from "react";
import { FaChevronDown, FaRegBell } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const nav = useNavigate();
  const activePage = useSelector((state) => state.activePage.value);
  let name = sessionStorage.getItem("name");
  let email = sessionStorage.getItem("email");

  const handleLogout = () => {
    sessionStorage.removeItem("atkn");
    sessionStorage.removeItem("name");
    sessionStorage.removeItem("email");
    localStorage.removeItem("atkn");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    nav("/");
  };

  return (
    <div className="h-16 w-full p-3 bg-base-100 flex items-center">
      <div className="flex-1">
        <a className=" text-2xl text-neutral-700 font-medium">{activePage}</a>
      </div>

      <div className="flex gap-2">
        {/* Search Box */}
        {/* <div className="form-control">
          <label className="input input-bordered flex items-center gap-2 focus-within:outline-none rounded-full">
            <GoSearch className="text-lg text-neutral-500" />
            <input
              type="text"
              className="grow text-neutral-700"
              placeholder="Search"
            />
          </label>
        </div> */}

        {/* Notification Button */}
        <button className="btn btn-circle p-3">
          <FaRegBell className="text-2xl" />
        </button>

        {/* Dropdown */}
        <div className="dropdown dropdown-end">
          <button className="btn flex rounded-full px-1 items-center">
            <div className="avatar">
              <div className="w-10 rounded-full">
                <img src="https://daisyui.com/images/stock/photo-1534528741775-53994a69daeb.jpg" />
              </div>
            </div>

            <div className="flex flex-col items-start">
              <p className="text-black text-sm">{name}</p>
              <p className="text-disable text-xs font-light text-ellipsis">
                {email}
              </p>
            </div>

            <div className="w-4 mx-2">
              <FaChevronDown />
            </div>
          </button>

          <ul
            tabIndex={0}
            className="mt-3 z-[1] p-2 shadow menu menu-sm dropdown-content bg-base-100 rounded-box w-52"
          >
            <li>
              <a className="justify-between text-neutral-700">
                Profile
                <span className="badge">New</span>
              </a>
            </li>
            <li>
              <a className="text-neutral-700">Settings</a>
            </li>
            <li>
              <a className="text-neutral-700" onClick={handleLogout}>
                Logout
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
